<template>
  <v-container class="container background-bg full-height" fluid>
    <v-row justify="center" align="center" class="mt-12">
      <v-col sm="6" lg="3" md="4">
        <v-card class="pa-4 d-flex flex-column align-center">
          <div>
            <img class="card-logo mt-2" src="../assets/enel_foundation_logo.png" />
          </div>

          <div class="title mt-12 primaryText--text">Enter your BeeZ-In Code</div>

          <v-form
            @submit.prevent="validateCode"
            class="px-4 mt-4 align-self-stretch d-flex flex-column"
          >
            <v-text-field
              flat
              v-model="code"
              name="code"
              label="Enter 8-digit BeeZ-In Code"
              @blur="$v.code.$touch"
              required
              :error-messages="codeRequiredMessage"
            />

            <v-alert v-if="hasError" type="error" class="caption pa-1 mt-4">{{ this.errorMessage }}</v-alert>

            <v-btn
              class="mt-12 mx-12"
              :disabled="$v.$invalid"
              type="submit"
              color="accent"
              :loading="loading"
              :value="code"
            >BeeZ In</v-btn>
          </v-form>
          <router-link :to="{
            name: 'login'
          }" class="mt-4">
            <v-btn class="text-none mt-4" color="accent" text medium>Already have account? Login</v-btn>
          </router-link>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

 
<script>
import { required, minLength } from "vuelidate/lib/validators";
import { mapActions } from "vuex";


export default {
  name: "BeezcodeScreen",
  data() {
    return {
      code: "",
      loading: false,
      errorMessage: ""
    };
  },
  created() {
  },
  validations: {
    code: {
      required,
      minLength: minLength(8)
    }
  },
  computed: {
    codeRequiredMessage() {
      const errors = [];
      if (!this.$v.code.$dirty) return [];
      !this.$v.code.required && errors.push("BeeZ In Code is required.");
      !this.$v.code.minLength &&
        errors.push("BeeZ In Code must be exactly 8 characters long");
      return errors;
    },
    hasError() {
      return this.errorMessage && this.errorMessage.length;
    }
  }, 
  methods: {
    ...mapActions("beezInCode", {
      validateBeezInCode: "validateBeezInCode",
      getSubmissionModule: "getSubmissionModule"
    }),

    async validateCode() {

      // perform form validation
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }      
      
      const submissionEnds = await this.$store.dispatch("auth/isSubmissionEnds", {}, { root: true });

      if (submissionEnds){
        this.$router.push({
          name: 'submissionEnd'
        });
        return;
      }


      // present loading indicator on button
      this.loading = true;

      try {

        const code = this.code.trim();
        
        // execute validation request
        await this.validateBeezInCode(code);    


        this.$router.replace({
          name: 'intro'
        });
      } catch (error) {        


        // set error message as returned from the server
        this.errorMessage = error.message;
        // hide error messsage after
        // 3 seconds
        setTimeout(() => {
          this.errorMessage = "";
        }, 3000);
      } finally {
        this.loading = false;
        this.code = "";
      }
    }
  }
};
</script>

 
